import { Controller, type FieldValues } from 'react-hook-form';

import { FieldSelect } from '@/components/ui/admin/field';
import { cn } from '@/lib/utils';
import { type CommonFormFieldProps, spanToClassName } from './form-input';

type Option = {
  label: string;
  value: string | number;
};

type FormSelectProps<T extends FieldValues> = CommonFormFieldProps<T> & {
  options: Option[];
  placeholder?: string;
};

export function FormSelect<T extends FieldValues>({
  name,
  control,
  label,
  options,
  placeholder = 'Selecionar',

  sm,
  md,
  lg,

  required,
  disabled,
  className,
}: FormSelectProps<T>) {
  return (
    <Controller
      name={name}
      control={control}
      disabled={disabled}
      render={({ field, fieldState }) => (
        <div className={cn(spanToClassName(sm, md, lg), className)}>
          <FieldSelect
            id={name}
            label={label}
            required={required}
            invalid={fieldState.invalid}
            disabled={field.disabled}
            value={field.value?.toString() ?? ''}
            onChange={field.onChange}
            placeholder={placeholder}
            options={options.map((option) => ({
              label: option.label,
              value: option.value.toString(),
            }))}
          />

          {fieldState.error && (
            <p className="mt-1.5 text-xs font-medium text-destructive">
              {fieldState.error.message}
            </p>
          )}
        </div>
      )}
    />
  );
}
